import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=a4169b02&scoped=true&"
import script from "./FilterBox.vue?vue&type=script&lang=ts&"
export * from "./FilterBox.vue?vue&type=script&lang=ts&"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=a4169b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4169b02",
  null
  
)

export default component.exports